import { RotateCw } from 'lucide-react'
import type { ReactNode } from 'react'

import { FilterBar } from '@/components/data/FilterBar'

/** Strip above a project section: facts and inputs on the left, Refresh on the right. */
export function SectionStrip({ children, onRefresh, label }: {
  children?: ReactNode
  onRefresh?: () => void
  /** what Refresh reloads, for its accessible name */
  label: string
}) {
  return (
    <FilterBar>
      {children}
      {onRefresh && (
        <button
          type="button"
          onClick={onRefresh}
          aria-label={`Refresh ${label}`}
          className="ml-auto inline-flex min-h-7 items-center gap-1 rounded-md px-2 text-[12px] text-text-2 transition-colors hover:bg-surface-raised hover:text-foreground"
        >
          <RotateCw aria-hidden className="size-3.5" />
          Refresh
        </button>
      )}
    </FilterBar>
  )
}

/** A section that could not load. */
export function SectionError({ children }: { children: ReactNode }) {
  return <p role="status" className="px-4 py-4 text-[13px] text-warn">{children}</p>
}

export const TOKEN_HINT = 'Jira token required (Settings → Tokens).'

/** Inline "add" field + button, for a section strip. */
export function AddField({ value, onChange, onAdd, placeholder, label }: {
  value: string
  onChange: (v: string) => void
  onAdd: () => void
  placeholder: string
  label: string
}) {
  return (
    <span className="flex items-center gap-1.5">
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && onAdd()}
        placeholder={placeholder}
        aria-label={label}
        className="h-7 w-48 rounded-md border border-input bg-surface px-2 font-mono text-[12px] text-foreground placeholder:text-text-3"
      />
      <button
        type="button"
        disabled={!value.trim()}
        onClick={onAdd}
        className="h-7 rounded-md border border-line-strong bg-surface-raised px-2.5 text-[12px] text-foreground transition-colors hover:bg-surface-active disabled:opacity-60"
      >
        Add
      </button>
    </span>
  )
}
